import TagManager from "react-gtm-module";
import { lazy } from "@fidget/common/utils/lazy";
import { config } from "@fidget/common/config/config";

const TagManagerConfig = {
  gtmId: config.services.gtmId
};

interface AbstractGtmService {
  addGoogleTagManager(): void;
  pushTag(tagManagerData: string): void;
}

class DummyGtmService implements AbstractGtmService {
  private static instance: DummyGtmService;
  addGoogleTagManager() {
    return;
  }
  pushTag(tagManagerData: string) {
    return;
  }

  static getInstance() {
    if (!DummyGtmService.instance) {
      DummyGtmService.instance = new DummyGtmService();
    }
    return DummyGtmService.instance;
  }
}

class GtmService implements AbstractGtmService {
  private static instance: GtmService;

  static getInstance() {
    if (!GtmService.instance) {
      GtmService.instance = new GtmService();
    }
    return GtmService.instance;
  }

  addGoogleTagManager() {
    const scripts: HTMLCollectionOf<HTMLScriptElement> =
      document.head.getElementsByTagName("script");
    const scriptPrefix = `"https://www.googletagmanager.com/gtm.js?id=${TagManagerConfig.gtmId}`;
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i]!.src && (scripts[i]!.src as string).startsWith(scriptPrefix)) {
        return;
      }
    }
    TagManager.initialize(TagManagerConfig);
  }

  pushTag(tagManagerData: string) {
    TagManager.dataLayer({
      dataLayer: {
        event: tagManagerData
      }
    });
  }
}

export const getGtmService = () =>
  lazy(() =>
    config.services.gtmScriptEnabled ? GtmService.getInstance() : DummyGtmService.getInstance()
  );
